// src/components/Welcome.js
import React from "react";

function Welcome(props) {
  return (
    <div
      style={{
        padding: "0.5rem",
        margin: "1rem",
      }}
    >
      {/* This input changes the value of name whenever something is typed*/}
      <input
        type="text"
        value={props.name}
        onChange={(e) => props.setName(e.target.value)}
        style={{
          padding: "0.5rem",
          borderRadius: "5px",
          border: "1px solid #000",
          width: "fit-content",
          color: "#2b2b2b",
        }}
      />  &lt;---- Try Changing the value of name
      <p>Hello, {props.name}</p>
    </div>
  );
}

export default Welcome;
